import { FC } from "react";
import cn from "classnames";
import styles from "../Scam.module.scss";

interface Props {
    currentPage: number;
    setCurrentPage(currentPage: number): void;
}

const Pagination: FC<Props> = ({ currentPage, setCurrentPage }) => {
    return (
        <div className={styles.pagination}>
            <button className={cn(styles.page, styles.previous)}>
                <img width={9} height={9} src="/images/scam/left.svg" alt="Go to the previous page" />
            </button>
            {[...new Array(5)]
                .map((_, i) => i + 1)
                .map((n) => (
                    <button
                        key={n}
                        onClick={() => setCurrentPage(n)}
                        className={cn(styles.page, {
                            [styles.active]: n === currentPage,
                        })}
                    >
                        {n}
                    </button>
                ))}
            <button className={styles.page}>...</button>
            <button className={styles.page}>10</button>
            <button className={cn(styles.page, styles.next)}>
                <img width={9} height={9} src="/images/scam/left.svg" alt="Go to the next page" />
            </button>
        </div>
    );
};

export default Pagination;
